module.exports = __webpack_public_path__ + "img/lnr-upload-white.ac56ae58.svg";